export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  // older browsers need the URL alive briefly after click
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export function parseContentDispositionFilename(
  contentDisposition: string | null | undefined,
  fallback: string,
): string {
  if (!contentDisposition) return fallback

  const star = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(contentDisposition)
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].replace(/^"|"$/g, ''))
    } catch {
      /* fall through */
    }
  }

  const plain = /filename=("?)([^";]+)\1/i.exec(contentDisposition)
  if (plain?.[2]) return plain[2]

  return fallback
}
